import { render, staticRenderFns } from "./tags_add.vue?vue&type=template&id=700a498f&scoped=true&"
import script from "./tags_add.vue?vue&type=script&lang=js&"
export * from "./tags_add.vue?vue&type=script&lang=js&"
import style0 from "./tags_add.vue?vue&type=style&index=0&id=700a498f&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700a498f",
  null
  
)

export default component.exports